import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import SVG from "./outline/filter.svg";
var FilterOutline_default = forwardRef(
  (props, ref) => /* @__PURE__ */ jsx(SVG, { ref, ...props })
);
export {
  FilterOutline_default as default
};
